import { Controller } from "@hotwired/stimulus"

// "Durchziehen" in the Stundenzettel Matrix: one dialog for the whole grid, opened from a row's
// button, which names the row's fill URL and Baustelle. The server does the rest — which days
// count, the bookings, the re-rendered row — and answers turbo streams: on success the dialog
// closes, on a refusal the message lands in it and it stays open on what was typed.
export default class extends Controller {
  static targets = ["dialog", "form", "hours", "site"]

  open(event) {
    event.preventDefault()
    const { url, site } = event.params

    this.formTarget.action = url
    this.siteTarget.textContent = site
    this.clearError()
    this.dialogTarget.showModal()
    this.hoursTarget.focus()
    this.hoursTarget.select()
  }

  close() {
    this.dialogTarget.close()
  }

  submitted(event) {
    if (event.detail.success) this.close()
  }

  clearError() {
    const error = this.dialogTarget.querySelector("[role=alert]")
    if (error) error.textContent = ""
  }
}
